@if ((items && items.length > 0) || webinarUrl || showContact) {
  <div class="position-sticky top-2">
    <div *ngIf="webinarUrl" class="card mb-4">
      <ul class="nav flex-column bg-white border-radius-lg p-3">
        <li class="nav-item text-sm text-bold">
          <div class="d-flex">
            <div class="checklist-info me-2">
              <h6 class="checklist-title mb-0">
                <a [href]="webinarUrl" target="_blank">
                  <i class="fa-brands fa-youtube fs-4 me-1" style="color: #ff0000"></i>
                </a>
              </h6>
            </div>
            <div class="checklist-info">
              <h6 class="checklist-title mb-0">
                <a [href]="webinarUrl" target="_blank"> Bekijk het webinar </a>
              </h6>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- div *ngIf="showContact" class="card mb-4">
      <ul class="nav flex-column bg-white border-radius-lg p-3">
        <li class="nav-item text-sm text-bold">
          <div class="d-flex">
            <div class="checklist-info me-2">
              <h6 class="checklist-title mb-0">
                <a href="https://assistonline.eu/contact" target="_blank">
                  <i class="fa fa-comment text-primary fs-4 me-1"></i>
                </a>
              </h6>
            </div>
            <div class="checklist-info">
              <h6 class="checklist-title mb-0">
                <a href="https://assistonline.eu/contact" target="_blank"> Feedback of vragen? </a>
              </h6>
            </div>
          </div>
        </li>
      </ul>
    </div -->
    <div *ngIf="items && items.length > 0" class="card top-1 mb-4">
      <ul class="nav flex-column bg-white border-radius-lg p-3">
        <li class="nav-item" *ngFor="let item of items">
          <a
            (click)="navigate(item)"
            class="text-body d-flex align-items-center py-2"
            [class.px-2]="item.validation == null"
            data-scroll=""
          >
            <div class="d-flex">
              <div class="checklist-info me-1" *ngIf="item.validation != null">
                <h6 class="checklist-title mb-0">
                  <i
                    *ngIf="!item.validation.valid"
                    class="fa-solid fa-circle-xmark text-danger me-2"
                    [title]="item.unCheckedTooltip ?? 'Deze vraag werd nog niet beantwoord'"
                  ></i>
                  <i
                    *ngIf="item.validation.valid"
                    class="fa-solid fa-circle-check text-success me-2"
                    [title]="item.checkedTooltip ?? 'Deze vraag werd beantwoord'"
                  ></i>
                </h6>
              </div>
              <div class="">
                <h6 class="mb-0">
                  <span>{{ item.label }}</span>
                </h6>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <ng-content></ng-content>
  </div>
}
